import { useContext, useDebugValue } from "react";
import AuthContext from "../Store/Auth-context"

export default function useAuth() {
    const { auth } = useContext(AuthContext)
    console.log(auth)

    useDebugValue(auth, auth => auth?.user ? "Logged In" : "Logged Out")

    return useContext(AuthContext)
}